import React from "react";
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/browser";
import "./../styles/global.css";
import Navbar from "./../components/Navbar";
import HomePage from "./home";
import PricingPage from "./pricing";
import MarketplacePage from "./marketplace";
import AuthPage from "./auth";
import SettingsPage from "./settings";
import LegalPage from "./legal";
import { Switch, Route, Router } from "./../util/router";
import PurchasePage from "./purchase";
import NotFoundPage from "./404";
import Footer from "./../components/Footer";
import "./../util/analytics";
import Chat from "./../components/Chat";
import { AuthProvider } from "./../util/auth";
import { QueryClientProvider } from "./../util/db";
import DashboardPage from "./../components/Dashboard.js";
import TipsPage from "./tips";

function App(props) {
  return (
    <QueryClientProvider>
      <AuthProvider>
        <Chat />
        <Router>
          <>
            <Navbar bgColor="bg-white" />

            <Switch>
              <Route exact path="/" component={HomePage} />

              <Route exact path="/pricing" component={PricingPage} />

              <Route exact path="/marketplace" component={MarketplacePage} />

              <Route exact path="/auth/:type" component={AuthPage} />

              <Route exact path="/settings/:section" component={SettingsPage} />

              <Route exact path="/legal/:section" component={LegalPage} />

              <Route exact path="/purchase/:plan" component={PurchasePage} />

              <Route exact path="/dashboard" component={DashboardPage} />

              <Route exact path="/tips" component={TipsPage} />

              <Route component={NotFoundPage} />
            </Switch>

            <Footer
              size="md"
              bgColor="bg-white"
              bgImage=""
              bgImageOpacity={1}
              textColor=""
              sticky={true}
            />
          </>
        </Router>
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;